export default __webpack_public_path__ + "static/media/logo.0388e36d.svg";